import React, { createContext, useContext, useEffect, useState } from 'react'
import { useOptimizelyPage } from '../hooks/use-optimizely-page'

const OptimizelyContext = createContext();

export const OptimizelyProvider = ({ children, pageIdentifier }) => {
    const { data: optimizelyData, isLoading: isOptimizelyLoading } = useOptimizelyPage(pageIdentifier)
    const [rewardPageBlock, setRewardPageBlock] = useState(null)

    useEffect(() => {
        const content = optimizelyData?.item?.MainContentArea?.[0]?.ContentLink?.Expanded

        switch (content?.__typename) {
            case 'RewardPageBlock':
                setRewardPageBlock(content)
                break;
            default:
                setRewardPageBlock(null)
        }
    }, [optimizelyData, isOptimizelyLoading])

    return (
        <OptimizelyContext.Provider value={{
            optimizelyData,
            rewardPageBlock,
            isOptimizelyLoading
        }}>
            {children}
        </OptimizelyContext.Provider>
    );
};

export const useOptimizely = () => {
    return useContext(OptimizelyContext);
};
